<template>
  <div class="filterIndex">
    <v-filterSection
      :filterItem="filterItem"
      :payload_key="filterItem.type + '_' + filterItem.id"
      v-if="filterItem.type == 'collection'"
    ></v-filterSection>
    <v-filterColor
      :filterItem="filterItem"
      :payload="payload[filterItem.type + '_' + filterItem.id]"
      :payload_key="filterItem.type + '_' + filterItem.id"
      v-if="list_color_style.includes(filterItem.type)"
    ></v-filterColor>
    <v-filterPrice
      :filterItem="filterItem"
      :payload="payload[filterItem.type + '_' + filterItem.id]"
      :payload_key="filterItem.type + '_' + filterItem.id"
      v-if="filterItem.type == 'price'"
    ></v-filterPrice>
    <!-- <v-filterSize
      :filterItem="filterItem"
      :payload="payload[filterItem.type + '_' + filterItem.id]"
      :payload_key="filterItem.type + '_' + filterItem.id"
      v-if="filterItem.type == 'tag'"
    ></v-filterSize> -->
  </div>
</template>
<script>
import vFilterSection from "./filterSection";
import vFilterColor from "./filterColor";
import vFilterPrice from "./filterPrice";
import vFilterSize from "./filterSize";
export default {
  props: ["filterItem", "payload"],
  data() {
    return {
      list_color_style:["color","size",'tag'],
    };
  },
  components: {
    vFilterSection,
    vFilterColor,
    vFilterPrice,
    vFilterSize,
  },
};
</script>
<style scoped lang='scss'>

</style>